export default "__VITE_PUBLIC_ASSET__38d9bdc4__"